(function () {
  'use strict';

  /* The sale strip scrolls away; once it does, pin the logo navbar to the top.
     position:sticky can't do this because the navbar lives in its own short
     section, so it's toggled to fixed on scroll with a spacer to avoid a jump. */
  function initToeSeparatorStickyNav() {
    if (!document.body.classList.contains('frido-toe-separator-page')) return;

    var nav = document.querySelector('.ts-nav');
    var strip = document.querySelector('.ts-topbar');
    if (!nav || !strip || !nav.parentNode) return;

    var spacer = document.createElement('div');
    spacer.setAttribute('data-ts-nav-spacer', '');
    spacer.style.height = '0px';
    nav.parentNode.insertBefore(spacer, nav.nextSibling);

    var stripH = strip.offsetHeight;
    var stuck = false;

    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var shouldStick = y >= stripH;
      if (shouldStick === stuck) return;
      stuck = shouldStick;
      if (stuck) {
        // Measure while the navbar is still in flow so the spacer matches its
        // real height (the logo image may have loaded after init).
        spacer.style.height = nav.offsetHeight + 'px';
        nav.classList.add('ts-nav--stuck');
      } else {
        nav.classList.remove('ts-nav--stuck');
        spacer.style.height = '0px';
      }
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      stripH = strip.offsetHeight;
      if (stuck) spacer.style.height = nav.offsetHeight + 'px';
      onScroll();
    });
  }

  function initToeSeparatorBuyGalleryLayout() {
    if (!document.body.classList.contains('frido-toe-separator-page')) return;

    var page = document.getElementById('PageContainer') || document.querySelector('main')  /* the layout this page was written against gave <main> the id PageContainer; this theme's main is #MainContent, so fall back to the element rather than the id */;
    if (!page) return;

    var galleryHost = page.querySelector('[data-ts-buy-gallery]');
    if (!galleryHost) return;

    var buyCard = page.querySelector('[data-frido-toe-separator-fold-item="buy"] .ts-buy-card');
    if (buyCard) buyCard.classList.add('ts-buy-card--has-gallery');

    if (galleryHost.getAttribute('data-ts-buy-gallery-mounted') === 'true') return;

    var gallerySection = page.querySelector(
      '.shopify-section:has([data-frido-toe-separator-fold-item="gallery"])'
    );
    if (!gallerySection) {
      var galleryEl = page.querySelector('[data-frido-toe-separator-fold-item="gallery"]');
      gallerySection = galleryEl ? galleryEl.closest('.shopify-section') : null;
    }

    if (!gallerySection || !buyCard) return;

    galleryHost.setAttribute('data-ts-buy-gallery-mounted', 'true');
    galleryHost.appendChild(gallerySection);
  }

  function dispatchGalleryColorChange(colorValue) {
    if (!colorValue) return;
    document.dispatchEvent(
      new CustomEvent('frido:pdp-gallery-color-change', {
        detail: { colorValue: colorValue },
      })
    );
  }

  var PINCODE_STORAGE_KEY = 'frido-pdp-delivery-pincode';

  function isValidPincode(value) {
    return /^\d{6}$/.test(String(value || '').trim());
  }

  function readStoredPincode() {
    try {
      return localStorage.getItem(PINCODE_STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function storePincode(pincode) {
    try {
      localStorage.setItem(PINCODE_STORAGE_KEY, pincode);
    } catch (e) {
      /* ignore */
    }
  }

  function formatPincodeError(apiError) {
    var hint = 'Please enter a correct pincode.';
    var detail = apiError && String(apiError).trim();
    if (detail) return detail + ' ' + hint;
    return hint;
  }

  function initDeliveryEstimate(productData) {
    var root = document.querySelector('[data-ts-delivery]');
    if (!root) return;

    var formView = root.querySelector('[data-ts-delivery-form]');
    var resultView = root.querySelector('[data-ts-delivery-result]');
    var input = root.querySelector('[data-ts-pincode-input]');
    var checkBtn = root.querySelector('[data-ts-pincode-check]');
    var editBtn = root.querySelector('[data-ts-pincode-edit]');
    var errorEl = root.querySelector('[data-ts-pincode-error]');
    var messageEl = root.querySelector('[data-ts-delivery-message]');
    var apiUrl =
      root.getAttribute('data-delivery-api') ||
      (productData && productData.deliveryApiUrl) ||
      'https://rapi.myfrido.com/api/v2/expected-delivery-date';
    var store =
      root.getAttribute('data-delivery-store') ||
      (productData && productData.deliveryStore) ||
      'myfrido';
    var isChecking = false;

    function showFormView() {
      root.classList.remove('has-delivery-result');
      if (formView) formView.hidden = false;
      if (resultView) resultView.hidden = true;
      if (errorEl) errorEl.hidden = true;
    }

    function showResultView(message) {
      if (messageEl) messageEl.textContent = message || '';
      root.classList.add('has-delivery-result');
      if (formView) formView.hidden = true;
      if (resultView) resultView.hidden = false;
      if (errorEl) errorEl.hidden = true;
    }

    function showError(message) {
      showFormView();
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
      if (input) input.setAttribute('aria-invalid', 'true');
    }

    function clearError() {
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
      if (input) input.removeAttribute('aria-invalid');
    }

    function setLoading(loading) {
      if (checkBtn) {
        checkBtn.disabled = loading;
        checkBtn.textContent = loading ? 'CHECKING...' : 'CHECK';
      }
      if (input) input.disabled = loading;
    }

    function checkPincode(silent) {
      if (isChecking) return;
      var pincode = input ? input.value.trim() : '';
      if (!isValidPincode(pincode)) {
        showError(formatPincodeError('Pincode must be exactly 6 digits'));
        return;
      }

      clearError();
      isChecking = true;
      setLoading(true);

      fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          pincode: pincode,
          store: store,
        }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          var data = result.data || {};
          if (data.success && data.message) {
            storePincode(pincode);
            showResultView(data.message);
            return;
          }
          if (silent) {
            showFormView();
          } else {
            showError(formatPincodeError(data.error));
          }
        })
        .catch(function () {
          if (silent) {
            showFormView();
          } else {
            showError(formatPincodeError('Unable to check delivery right now'));
          }
        })
        .finally(function () {
          isChecking = false;
          setLoading(false);
        });
    }

    if (checkBtn) {
      checkBtn.addEventListener('click', function () {
        checkPincode(false);
      });
    }

    if (input) {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          checkPincode(false);
        }
      });
      input.addEventListener('input', function () {
        var digits = input.value.replace(/\D/g, '').slice(0, 6);
        if (input.value !== digits) input.value = digits;
        clearError();
      });
    }

    if (editBtn) {
      editBtn.addEventListener('click', function () {
        showFormView();
        if (input) {
          input.focus();
          input.select();
        }
      });
    }

    var saved = readStoredPincode();
    if (saved && input) {
      input.value = saved;
      checkPincode(true);
    }
  }

  function initSizeChart() {
    var chart = document.getElementById('tsSizeChart');
    if (!chart) return;

    function open() {
      chart.classList.add('show');
      chart.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      chart.classList.remove('show');
      chart.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    Array.prototype.forEach.call(
      document.querySelectorAll('[data-ts-size-chart-open]'),
      function (btn) {
        btn.addEventListener('click', open);
      }
    );
    Array.prototype.forEach.call(
      chart.querySelectorAll('[data-ts-size-chart-close]'),
      function (btn) {
        btn.addEventListener('click', close);
      }
    );
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && chart.classList.contains('show')) close();
    });
  }

  function initToeSeparatorPage() {
    var dataNode = document.getElementById('tsProductData');
    if (!dataNode) return;

    var productData = {};
    try {
      productData = JSON.parse(dataNode.textContent);
    } catch (e) {
      return;
    }

    var selectedPack = '';
    var selectedVariantId = String(productData.defaultVariantId || '');
    var selectedColor = String(productData.defaultColor || '');
    var selectedSize = String(productData.defaultSize || '');
    var packQtyMap = productData.packQty || { 1: 1, 2: 2 };
    var packDiscountCents = productData.packDiscountCents || { 2: 9900 };
    var modalPairSelections = [];
    /* Gallery slides are keyed by colour only. The gallery tears down the swiper
       and resets to slide 1 on every colour-change event, so only fire when the
       colour actually changed — a size change must leave the gallery alone. */
    var lastGalleryColor = null;

    function formatMoney(cents) {
      var amount = Number(cents || 0) / 100;
      var formatted = amount.toLocaleString('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
      });
      return '₹' + formatted;
    }

    function qs(sel) {
      return document.querySelector(sel);
    }
    function qsa(sel) {
      return Array.prototype.slice.call(document.querySelectorAll(sel));
    }

    function findVariant(color, size) {
      var variants = productData.variants || [];
      var i;
      for (i = 0; i < variants.length; i++) {
        if (variants[i].color === color && variants[i].size === size) return variants[i];
      }
      return null;
    }

    function getSelectedVariant() {
      var variants = productData.variants || [];
      var i;
      for (i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(selectedVariantId)) return variants[i];
      }
      return variants[0] || null;
    }

    function getUniqueColors() {
      var seen = {};
      var list = [];
      (productData.variants || []).forEach(function (v) {
        if (!v.color || seen[v.color]) return;
        seen[v.color] = true;
        list.push(v);
      });
      return list;
    }

    function getUniqueSizes() {
      var seen = {};
      var list = [];
      (productData.variants || []).forEach(function (v) {
        if (!v.size || seen[v.size]) return;
        seen[v.size] = true;
        list.push(v.size);
      });
      return list;
    }

    function getPackConfig() {
      var packs = productData.packs || {};
      return (
        packs[selectedPack] || packs['1'] || { qty: 1, discountAmount: null, discountCode: null }
      );
    }

    function buildCheckoutUrl(variantIds) {
      var counts = {};
      var order = [];
      variantIds.forEach(function (id) {
        var key = String(id);
        if (counts[key]) counts[key]++;
        else {
          counts[key] = 1;
          order.push(key);
        }
      });
      var qty = variantIds.length;
      var name =
        (productData.title || 'Frido Orthotics Toe Separator') +
        ' - ' +
        qty +
        (qty > 1 ? ' Pairs' : ' Pair');
      var parts = order.map(function (id) {
        return id + ':' + counts[id];
      });
      var pack = getPackConfig();
      var query = ['rfname=' + encodeURIComponent(name), 'tt-cart-mod=true'];
      if (pack.discountAmount) {
        query.push('disam=__' + encodeURIComponent(pack.discountAmount));
      }
      if (pack.discountCode) {
        query.push('discount=' + encodeURIComponent(pack.discountCode));
      }
      return (productData.cartUrl || '/cart') + '/' + parts.join(',') + '?' + query.join('&');
    }

    function setButtonLoading(btn, loading) {
      if (!btn) return;
      var textEl = btn.querySelector('.btnText');
      var spinEl = btn.querySelector('.spin');
      btn.classList.toggle('loading', !!loading);
      btn.classList.toggle('is-loading', !!loading);
      btn.disabled = !!loading;
      if (textEl) {
        textEl.hidden = false;
        textEl.setAttribute('aria-hidden', loading ? 'true' : 'false');
      }
      if (spinEl) spinEl.hidden = !loading;
      if (loading) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
    }

    function checkoutWithVariants(variantIds, btn) {
      var cartUrl = buildCheckoutUrl(variantIds);
      var pack = getPackConfig();
      var expectedCount = variantIds.length;
      var fallbackUrl = cartUrl.indexOf('http') === 0 ? cartUrl : 'https://myfrido.com' + cartUrl;

      setButtonLoading(btn, true);

      var isOptionSheetBtn = !!(btn && btn.closest('#tsColorSheet'));

      if (
        window.FridoPdpGokwikCheckout &&
        window.FridoPdpGokwikCheckout.shouldUseGokwik &&
        window.FridoPdpGokwikCheckout.shouldUseGokwik() &&
        window.FridoPdpGokwikCheckout.prepareCartAndCheckout
      ) {
        window.FridoPdpGokwikCheckout.prepareCartAndCheckout({
          cartUrl: cartUrl,
          uiButton: isOptionSheetBtn ? null : btn,
          expectedCount: expectedCount,
          discountCode: pack.discountCode || '',
          fallbackUrl: fallbackUrl,
          onComplete: function () {
            setButtonLoading(btn, false);
            if (isOptionSheetBtn) closeOptionSheet();
          },
          onError: function () {
            setButtonLoading(btn, false);
          },
        });
        return;
      }

      window.location.href = fallbackUrl;
    }

    function updateMainPriceDisplay(variant) {
      if (!variant) return;
      var priceEl = qs('#tsMainPrice');
      var mrpEl = qs('#tsMainMrp');
      var saveEl = qs('#tsMainSave');
      var saleCents = Number(variant.price || 0);
      var mrpCents = Number(variant.compareAtPrice || 0);
      if (priceEl) priceEl.textContent = formatMoney(saleCents);
      if (mrpEl) {
        if (mrpCents > saleCents && mrpCents > 0) {
          mrpEl.textContent = formatMoney(mrpCents);
          mrpEl.hidden = false;
        } else {
          mrpEl.hidden = true;
        }
      }
      if (saveEl) {
        if (mrpCents > saleCents && mrpCents > 0) {
          var pct = Math.round(((mrpCents - saleCents) * 100) / mrpCents);
          saveEl.textContent = 'Save ' + pct + '%';
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
    }

    function updatePackPrices(unitPriceCents) {
      var unit = Number(unitPriceCents || 0);
      var pack2Discount = Number(packDiscountCents['2'] || 9900);
      var pack1Price = unit;
      var pack2Price = unit * 2 - pack2Discount;
      var perPair2 = Math.round(pack2Price / 2);

      qsa('.ts-pack-btn').forEach(function (btn) {
        var pack = btn.getAttribute('data-pack');
        var priceText = formatMoney(unit);
        var metaEl = btn.querySelector('.ts-pack-meta');
        if (pack === '1') {
          priceText = formatMoney(pack1Price);
        } else if (pack === '2') {
          priceText = formatMoney(pack2Price);
          if (metaEl) metaEl.textContent = formatMoney(perPair2) + ' / pair';
        }
        btn.setAttribute('data-price', priceText);
        var priceEl = btn.querySelector('.ts-pack-price');
        if (priceEl) priceEl.textContent = priceText;
      });

      if (selectedPack) {
        var activePackBtn = qs('.ts-pack-btn[data-pack="' + selectedPack + '"]');
        if (activePackBtn) {
          setPack(
            selectedPack,
            activePackBtn.getAttribute('data-price'),
            activePackBtn.getAttribute('data-label')
          );
        }
      }
    }

    function setPack(pack, price, label) {
      selectedPack = pack;
      qsa('.ts-pack-btn').forEach(function (btn) {
        btn.classList.toggle('active', btn.getAttribute('data-pack') === pack);
      });
      if (qs('#tsStickyPrice')) qs('#tsStickyPrice').textContent = price;
      if (qs('#tsStickyPack')) qs('#tsStickyPack').textContent = label;
      var packValueEl = qs('[data-ts-pack-value]');
      if (packValueEl && label) packValueEl.textContent = label;
    }

    function scrollActiveColorInScroll(scrollEl, behavior, btn) {
      if (!scrollEl) return;
      var targetBtn = btn || scrollEl.querySelector('.ts-color-btn.active');
      if (!targetBtn) return;

      var btnRect = targetBtn.getBoundingClientRect();
      var containerRect = scrollEl.getBoundingClientRect();
      var delta = btnRect.left + btnRect.width / 2 - (containerRect.left + containerRect.width / 2);
      var nextLeft = Math.max(
        0,
        Math.min(scrollEl.scrollLeft + delta, scrollEl.scrollWidth - scrollEl.clientWidth)
      );

      if (scrollEl.scrollTo) {
        scrollEl.scrollTo({ left: nextLeft, behavior: behavior || 'smooth' });
      } else {
        scrollEl.scrollLeft = nextLeft;
      }
    }

    function scrollColorIntoView(btn) {
      if (!btn) return;
      var scrollEl = btn.closest('.ts-colors--scroll');
      if (scrollEl) {
        scrollActiveColorInScroll(scrollEl, 'smooth', btn);
        updateColorScrollPeek();
        return;
      }
      if (btn.scrollIntoView) {
        btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        updateColorScrollPeek();
      }
    }

    function updateColorScrollPeek() {
      qsa('.ts-colors-scroll-wrap').forEach(function (wrap) {
        var scroll = wrap.querySelector('.ts-colors--scroll');
        if (!scroll) return;

        if (!window.matchMedia('(max-width: 760px)').matches) {
          wrap.classList.remove('ts-colors-scroll-wrap--overflow', 'ts-colors-scroll-wrap--end');
          return;
        }

        var overflows = scroll.scrollWidth > scroll.clientWidth + 2;
        var atEnd = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 2;
        wrap.classList.toggle('ts-colors-scroll-wrap--overflow', overflows);
        wrap.classList.toggle('ts-colors-scroll-wrap--end', !overflows || atEnd);
      });
    }

    function initColorScrollPeek() {
      if (window.__tsColorScrollPeekBound) return;
      window.__tsColorScrollPeekBound = true;

      document.addEventListener(
        'scroll',
        function (event) {
          if (
            event.target &&
            event.target.classList &&
            event.target.classList.contains('ts-colors--scroll')
          ) {
            updateColorScrollPeek();
          }
        },
        { passive: true, capture: true }
      );
      window.addEventListener('resize', updateColorScrollPeek);
      updateColorScrollPeek();
    }

    /* Main buy-box selection — colour and size resolve to one variant. */

    function applySelection() {
      var variant = findVariant(selectedColor, selectedSize);
      if (!variant) return;
      selectedVariantId = String(variant.id);
      updateMainPriceDisplay(variant);
      updatePackPrices(variant.price || productData.unitPriceCents);

      var colorValueEl = qs('[data-ts-color-value]');
      if (colorValueEl) colorValueEl.textContent = selectedColor;
      var sizeValueEl = qs('[data-ts-size-value]');
      if (sizeValueEl) sizeValueEl.textContent = selectedSize;

      var galleryColor = variant.galleryColor || variant.color;
      if (galleryColor && galleryColor !== lastGalleryColor) {
        lastGalleryColor = galleryColor;
        dispatchGalleryColorChange(galleryColor);
      }
    }

    function setMainColor(btn) {
      if (!btn) return;
      selectedColor = btn.getAttribute('data-color') || selectedColor;
      qsa('[data-ts-colors-scroll] .ts-color-btn').forEach(function (el) {
        var on = el === btn;
        el.classList.toggle('active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      scrollColorIntoView(btn);
      applySelection();
    }

    function setMainSize(btn) {
      if (!btn) return;
      selectedSize = btn.getAttribute('data-size') || selectedSize;
      qsa('[data-ts-sizes] .ts-size-btn').forEach(function (el) {
        var on = el === btn;
        el.classList.toggle('active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applySelection();
    }

    /* Option sheet — one colour + size row per pair. */

    function getDefaultPairSelection() {
      return { color: selectedColor, size: selectedSize };
    }

    function buildSizeRow(index, selection, onPick) {
      var wrap = document.createElement('div');
      wrap.className = 'ts-size-picker';
      wrap.innerHTML =
        '<div class="ts-size-picker__head"><span class="ts-size-picker__title">Choose your size</span></div>' +
        '<p class="ts-size-value" data-ts-pair-size-label="' +
        index +
        '"></p>' +
        '<div class="ts-sizes ts-sizes--modal" data-ts-pair-sizes="' +
        index +
        '" role="list"></div>';

      var host = wrap.querySelector('[data-ts-pair-sizes]');
      var label = wrap.querySelector('[data-ts-pair-size-label]');

      function render() {
        host.innerHTML = '';
        if (label) label.textContent = selection.size;
        getUniqueSizes().forEach(function (size) {
          var isActive = size === selection.size;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ts-size-btn' + (isActive ? ' active' : '');
          btn.setAttribute('role', 'listitem');
          btn.setAttribute('data-size', size);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          btn.textContent = size;
          btn.addEventListener('click', function () {
            onPick({ color: selection.color, size: size });
          });
          host.appendChild(btn);
        });
      }

      render();
      return wrap;
    }

    function buildColorRow(index, selection, onPick) {
      var wrap = document.createElement('div');
      wrap.className = 'ts-color-picker';
      wrap.innerHTML =
        '<div class="ts-color-picker__head"><span class="ts-color-picker__title">Choose your colour</span></div>' +
        '<p class="ts-color-value" data-ts-pair-color-label="' +
        index +
        '"></p>' +
        '<div class="ts-colors-scroll-wrap ts-colors-scroll-wrap--modal">' +
        '<div class="ts-colors ts-colors--scroll ts-colors--modal" data-ts-pair-swatches="' +
        index +
        '" role="list"></div></div>';

      var host = wrap.querySelector('[data-ts-pair-swatches]');
      var label = wrap.querySelector('[data-ts-pair-color-label]');

      function render() {
        host.innerHTML = '';
        if (label) label.textContent = selection.color;
        getUniqueColors().forEach(function (v) {
          var isActive = v.color === selection.color;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ts-color-btn' + (isActive ? ' active' : '');
          btn.setAttribute('role', 'listitem');
          btn.setAttribute('data-color', v.color);
          btn.setAttribute('aria-label', v.color);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

          var swatch = document.createElement('span');
          swatch.className = 'ts-color-swatch';
          if (v.swatchImage) {
            var img = document.createElement('img');
            img.src = v.swatchImage;
            img.alt = '';
            img.width = 56;
            img.height = 56;
            img.loading = 'lazy';
            img.decoding = 'async';
            swatch.appendChild(img);
          }
          btn.appendChild(swatch);

          btn.addEventListener('click', function () {
            onPick({ color: v.color, size: selection.size });
          });
          host.appendChild(btn);
        });
        scrollActiveColorInScroll(host, 'auto');
      }

      render();
      return wrap;
    }

    function refreshModalPairRows(qty) {
      var list = qs('[data-ts-color-sheet-pairs]');
      if (!list) return;

      list.innerHTML = '';
      var i;
      for (i = 0; i < qty; i++) {
        (function (index) {
          var row = document.createElement('div');
          row.className = 'ts-color-sheet-row';

          if (qty > 1) {
            var head = document.createElement('div');
            head.className = 'ts-color-sheet-row-head';
            head.textContent = 'Pair ' + (index + 1);
            row.appendChild(head);
          }
          list.appendChild(row);

          function pick(selection) {
            modalPairSelections[index] = { color: selection.color, size: selection.size };
            renderRow();
            updateColorScrollPeek();
          }

          function renderRow() {
            var selection = modalPairSelections[index];
            Array.prototype.slice
              .call(row.querySelectorAll('.ts-size-picker, .ts-color-picker'))
              .forEach(function (el) {
                el.remove();
              });
            row.appendChild(buildSizeRow(index, selection, pick));
            row.appendChild(buildColorRow(index, selection, pick));
          }

          if (!modalPairSelections[index]) {
            modalPairSelections[index] = getDefaultPairSelection();
          }
          renderRow();
        })(i);
      }
    }

    function openOptionSheet(qty) {
      var defaultSelection = getDefaultPairSelection();
      modalPairSelections = [];
      var i;
      for (i = 0; i < qty; i++) {
        modalPairSelections.push({
          color: defaultSelection.color,
          size: defaultSelection.size,
        });
      }

      refreshModalPairRows(qty);
      requestAnimationFrame(function () {
        requestAnimationFrame(updateColorScrollPeek);
      });

      var checkoutBtn = qs('[data-ts-color-checkout]');
      if (checkoutBtn) setButtonLoading(checkoutBtn, false);

      closeSheet();

      var overlay = qs('#tsColorOverlay');
      var sheet = qs('#tsColorSheet');
      if (overlay) overlay.classList.add('show');
      if (sheet) {
        sheet.classList.add('show');
        sheet.setAttribute('aria-hidden', 'false');
      }
      document.body.style.overflow = 'hidden';
    }

    function closeOptionSheet() {
      var overlay = qs('#tsColorOverlay');
      var sheet = qs('#tsColorSheet');
      if (overlay) overlay.classList.remove('show');
      if (sheet) {
        sheet.classList.remove('show');
        sheet.setAttribute('aria-hidden', 'true');
      }
      var packSheet = qs('#tsSheet');
      if (!packSheet || !packSheet.classList.contains('show')) {
        document.body.style.overflow = '';
      }
    }

    function confirmOptionCheckout(btn) {
      var ids = modalPairSelections.map(function (sel) {
        var variant = findVariant(sel.color, sel.size);
        return variant ? variant.id : selectedVariantId;
      });
      checkoutWithVariants(ids, btn);
    }

    function openSheet() {
      if (qs('#tsOverlay')) qs('#tsOverlay').classList.add('show');
      if (qs('#tsSheet')) qs('#tsSheet').classList.add('show');
    }

    function closeSheet() {
      if (qs('#tsOverlay')) qs('#tsOverlay').classList.remove('show');
      if (qs('#tsSheet')) qs('#tsSheet').classList.remove('show');
    }

    // Scroll the buy box to just under the sticky logo bar instead of centering
    // it — centering tucks the top of the card behind the fixed navbar.
    function scrollBuyBoxIntoView() {
      var box = qs('#tsBuyBox');
      if (!box) return;
      var nav = document.querySelector('.ts-nav');
      var navH = nav ? nav.offsetHeight : 0;
      var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var target = box.getBoundingClientRect().top + currentY - navH - 12;
      window.scrollTo({ top: target < 0 ? 0 : target, behavior: 'smooth' });
    }

    function shakePacks() {
      qsa('[data-pack-group]').forEach(function (group) {
        group.classList.remove('ts-shake');
        group.offsetHeight;
        group.classList.add('ts-shake');
      });
      scrollBuyBoxIntoView();
    }

    function buyNow(btn) {
      if (!selectedPack) {
        openSheet();
        shakePacks();
        return;
      }

      var qty = packQtyMap[selectedPack] || packQtyMap['1'] || 1;

      // Only one colour is sellable and the size is fixed (universal), so there
      // is nothing to pick per pair — skip the options sheet and check out the
      // selected variant directly, qty times.
      if (getUniqueColors().length <= 1) {
        var ids = [];
        var i;
        for (i = 0; i < qty; i++) ids.push(selectedVariantId);
        checkoutWithVariants(ids, btn);
        return;
      }

      var fromFinal = btn && btn.closest('.ts-final');
      var fromSticky = btn && btn.closest('#tsSticky');
      var fromSheet = btn && btn.closest('#tsSheet');
      var needsOptionsSheet = !!(fromFinal || fromSticky || fromSheet);

      if (qty > 1 || needsOptionsSheet) {
        openOptionSheet(qty);
        return;
      }

      checkoutWithVariants([selectedVariantId], btn);
    }

    function goToBuy() {
      scrollBuyBoxIntoView();
    }

    qsa('.ts-pack-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setPack(
          btn.getAttribute('data-pack'),
          btn.getAttribute('data-price'),
          btn.getAttribute('data-label')
        );
      });
    });
    qsa('[data-buy-now]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        buyNow(btn);
      });
    });
    qsa('[data-sticky-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!selectedPack) openSheet();
        else buyNow(btn);
      });
    });
    qsa('[data-scroll-buy]').forEach(function (btn) {
      btn.addEventListener('click', goToBuy);
    });
    qsa('[data-ts-colors-scroll] .ts-color-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMainColor(btn);
      });
    });
    qsa('[data-ts-sizes] .ts-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMainSize(btn);
      });
    });

    applySelection();
    var activeColorBtn = qs('[data-ts-colors-scroll] .ts-color-btn.active');
    if (activeColorBtn) scrollColorIntoView(activeColorBtn);
    initColorScrollPeek();

    var defaultPack = String(productData.defaultPack || '2');
    var defaultPackBtn = qs('.ts-pack-btn[data-pack="' + defaultPack + '"]');
    if (defaultPackBtn) {
      setPack(
        defaultPackBtn.getAttribute('data-pack'),
        defaultPackBtn.getAttribute('data-price'),
        defaultPackBtn.getAttribute('data-label')
      );
    }

    var sticky = qs('#tsSticky');
    var buyBox = qs('#tsBuyBox');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sticky.classList.toggle('show', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      obs.observe(buyBox);
    }

    initDeliveryEstimate(productData);
    initSizeChart();

    qsa('.ts-faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.parentNode;
        qsa('.ts-faq-item').forEach(function (other) {
          if (other !== item) {
            other.classList.remove('open');
            other.querySelector('.ts-faq-q span:last-child').textContent = '+';
          }
        });
        var open = item.classList.toggle('open');
        q.querySelector('span:last-child').textContent = open ? '−' : '+';
      });
    });

    if (qs('#tsOverlay')) qs('#tsOverlay').addEventListener('click', closeSheet);
    if (qs('#tsClose')) qs('#tsClose').addEventListener('click', closeSheet);

    if (qs('#tsColorOverlay')) {
      qs('#tsColorOverlay').addEventListener('click', closeOptionSheet);
    }
    if (qs('#tsColorClose')) {
      qs('#tsColorClose').addEventListener('click', closeOptionSheet);
    }
    if (qs('[data-ts-color-cancel]')) {
      qs('[data-ts-color-cancel]').addEventListener('click', closeOptionSheet);
    }
    if (qs('[data-ts-color-checkout]')) {
      qs('[data-ts-color-checkout]').addEventListener('click', function () {
        confirmOptionCheckout(qs('[data-ts-color-checkout]'));
      });
    }
  }

  function init() {
    initToeSeparatorBuyGalleryLayout();
    initToeSeparatorStickyNav();
    initToeSeparatorPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
